/*
Copyright (c) 2018-2020 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
import { styled } from '../styles/index.js';
export var StyledRoot = styled('div', {
  display: 'flex'
});
StyledRoot.displayName = "StyledRoot";